module.exports = __webpack_public_path__ + "img/cog-white.3a139b12.svg";